export const hasProperty = (obj: any, key: string) => {
  return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
};
